import ProtectedRouteTemplate from '@/components/templates/ProtectedRouteTemplate'
import BrowseDesignsPage from '@/pages/protected/designs/Browse'
import BrowseProjectsPage from '@/pages/protected/projects/Browse'
import EditProfilePage from '@/pages/protected/profile/Edit'
import ViewDesignPage from '@/pages/protected/designs/View'
import { RouteObject } from 'react-router-dom'
import ShowProjectPage from '@/pages/protected/projects/Show'
import TeamMembersPage from '@/pages/protected/team-members/Browse'

export const ProtectedRoutes = () => {
  return <ProtectedRouteTemplate />
}

export const protectedRoutes: RouteObject[] = [
  {
    element: <ProtectedRoutes />,
    children: [
      {
        path: '/designs',
        element: <BrowseDesignsPage />,
      },
      {
        path: '/designs/:designId',
        element: <ViewDesignPage />,
      },
      {
        path: '/projects',
        element: <BrowseProjectsPage />,
      },
      {
        path: '/projects/:projectId',
        element: <ShowProjectPage />,
      },
      {
        path: '/profile',
        element: <EditProfilePage />,
      },
      {
        path: '/team-members',
        element: <TeamMembersPage />,
      },
    ],
  },
]
